import { IdCard, Smartphone, Mail, Landmark, Users } from 'lucide-react';

export const UTT_LINKS = {
  android: 'https://play.google.com/store/apps/details?id=com.utt.tz',
  ios: 'https://apps.apple.com/tz/app/utt-amis/id1478599443',
  portal: 'https://uwekezaji.uttamis.co.tz/ISSDIGITAL/dist/main/auth-login',
  ussd: 'tel:*150*82%23',
  helpline: 'tel:0800112020',
};

export const CHECKLIST = [
  { key: 'nida', icon: IdCard, en: 'NIDA number (National ID)', sw: 'Namba ya NIDA (Kitambulisho cha Taifa)',
    hintEn: 'Used to verify your identity — you will answer NIDA questions.', hintSw: 'Inatumika kuthibitisha utambulisho — utajibu maswali ya NIDA.' },
  { key: 'phone', icon: Smartphone, en: 'Mobile number registered in your name', sw: 'Namba ya simu iliyosajiliwa kwa jina lako',
    hintEn: 'You will receive an SMS OTP. Use the same number to pay by mobile money.', hintSw: 'Utapokea OTP kwa SMS. Tumia namba hiyo kulipa kwa pesa ya simu.' },
  { key: 'email', icon: Mail, en: 'Active email address', sw: 'Barua pepe inayotumika',
    hintEn: 'UTT AMIS may ask you to confirm it.', hintSw: 'UTT AMIS inaweza kukuomba uithibitishe.' },
  { key: 'bank', icon: Landmark, en: 'Bank account details (bank, branch, account no.)', sw: 'Taarifa za benki (benki, tawi, namba ya akaunti)',
    hintEn: 'Redemptions and dividends are paid to this account.', hintSw: 'Mauzo ya vipande na gawio hulipwa kwenye akaunti hii.' },
  { key: 'nominee', icon: Users, en: 'Nominee / heir details (name, relationship, phone)', sw: 'Taarifa za mrithi (jina, uhusiano, simu)',
    hintEn: 'Who inherits your units. Have their full name and phone ready.', hintSw: 'Atakayerithi vipande vyako. Andaa jina kamili na simu yake.' },
];

// Steps from the official UTT AMIS "Jinsi ya Kujisajili" brochure.
export const REGISTER_STEPS = [
  { id: 'a1', en: 'Open the UTT AMIS app (download it below if you don’t have it)', sw: 'Fungua App yako ya UTT AMIS (ipakue hapa chini kama huna)', links: ['android', 'ios'] },
  { id: 'a2', en: 'Choose the registration type: “Sign Up as New Investor”', sw: 'Chagua aina ya usajili: “Sign Up as New Investor”' },
  { id: 'a3', en: 'Choose the registration group: “Individual”', sw: 'Chagua kundi la usajili: “Individual”' },
  { id: 'a4', en: 'Enter your NIDA number for verification', sw: 'Weka namba yako ya NIDA kwa ajili ya uthibitisho' },
  { id: 'a5', en: 'Enter your phone number for verification', sw: 'Weka namba yako ya simu kwa ajili ya uthibitishaji' },
  { id: 'a6', en: 'Enter the SMS OTP — you may also need to confirm your email', sw: 'Weka OTP uliyopokea kwa SMS — huenda ukahitaji kuthibitisha barua pepe pia' },
  { id: 'a7', en: 'Answer the NIDA identification questions', sw: 'Jibu maswali ya utambuzi kutoka NIDA' },
  { id: 'a8', en: 'You receive a “Congratulations” message — registration complete', sw: 'Utapokea ujumbe wa Hongera — usajili umekamilika' },
  { id: 'a9', en: 'Create your Username, Password and PIN, then submit', sw: 'Tengeneza User Name, Password na PIN kisha wasilisha' },
];

export const ACCOUNT_STEPS = [
  { id: 'b1', en: 'In the UTT AMIS app, choose “Create account”', sw: 'Kwenye App ya UTT AMIS, chagua “Create account”' },
  { id: 'b2', en: 'Choose the fund type (the fund you picked in step 2)', sw: 'Chagua aina ya mfuko (mfuko uliouchagua hatua ya 2)' },
  { id: 'b3', en: 'Enter your current address', sw: 'Weka anuani yako ya sasa (current address)' },
  { id: 'b4', en: 'Enter your bank details and confirm them', sw: 'Weka taarifa zako za benki na kuzihakiki' },
  { id: 'b5', en: 'Enter your nominee / heir details', sw: 'Weka taarifa za mrithi/warithi (nominees)' },
  { id: 'b6', en: 'Confirm all your details are correct', sw: 'Thibitisha uhakiki wa taarifa zako' },
  { id: 'b7', en: 'You receive a “Congratulations” message showing your account number', sw: 'Utapokea ujumbe wa Hongera unaoonyesha namba ya akaunti yako' },
];

export const WIZARD_STAGES = [
  { id: 'fund', en: 'Choose fund', sw: 'Chagua mfuko' },
  { id: 'apply', en: 'Your details', sw: 'Taarifa zako' },
  { id: 'awaiting', en: 'UTT registration', sw: 'Usajili UTT' },
  { id: 'fund_account', en: 'Fund', sw: 'Weka pesa' },
];

export const stageIndex = (stage) => {
  const i = WIZARD_STAGES.findIndex((s) => s.id === stage);
  return i === -1 ? WIZARD_STAGES.length - 1 : i;
};
